/**
 * Cross-component notifications emitted by Cropping3DExtension.
 *
 * The extension owns the live THREE.Box3 while feature components own any
 * persistence. Keeping the event generic lets consumers snapshot the final
 * bounds without coupling the viewer extension to verification state.
 */
export const CROP_BOX_EVENTS = Object.freeze({
  DRAG_END: 'crop-box:drag-end',
});
